<template>
    <section>
        <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

        <b-table :data="combos"

                 hoverable
                 bordered

                 narrowed
                 paginated
        >
            <b-table-column field="name" label="Название" centered>
                <template v-slot="props">
                    {{ props.row.name }}
                </template>
            </b-table-column>

            <b-table-column field="description" label="Описание" centered>
                <template v-slot="props">
                    {{ props.row.description }}
                </template>
            </b-table-column>

            <b-table-column field="price" label="Цена" centered>
                <template v-slot="props">
                    {{ props.row.price }}
                </template>
            </b-table-column>

            <b-table-column field="image" label="Изображение" width="200" centered>
                <template v-slot="props">
                    <img :src="props.row.image" alt/>
                </template>
            </b-table-column>

            <b-table-column field="edit" label="Действия" centered>
                <template v-slot="props">
                    <div class="buttons">
                        <b-button type="is-primary" icon-right="pencil-outline"
                                  tag="router-link" :to="{ name: 'ComboEdit', params: {id: props.row.id} }"

                                  :disabled="loading"
                        />

                        <b-button type="is-primary" icon-right="arrow-down-bold"
                                  @click="downOrder(props.row.id)" v-if="props.index + 1 !== combos.length"

                                  :disabled="loading"
                        />

                        <b-button type="is-primary" icon-right="arrow-up-bold"
                                  @click="upOrder(props.row.id)" v-if="props.index !== 0"

                                  :disabled="loading"
                        />
                    </div>
                </template>
            </b-table-column>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                    icon="emoticon-frown-outline"
                                    size="is-large"
                            />
                        </p>
                        <p>Комбо отсутствуют</p>
                    </div>
                </section>
            </template>
        </b-table>
    </section>
</template>

<script>
import comboRepository from "../../repository/comboRepository";

export default {
    data() {
        return {
            loading: false,
            combos: []
        }
    },
    methods: {
        fetchData() {
            this.loading = true;

            return comboRepository.list()
                .then(({data}) => {
                    this.combos = data
                })
                .then(() => this.$buefy.toast.open('Комбо загружены'))
                .catch(() => this.$buefy.toast.open('Ошибка при загрузке комбо'))
                .finally(() => {
                    this.loading = false
                })
        },
        upOrder(comboId) {
            this.loading = true;

            comboRepository.upOrder(comboId)
                .then(() => this.fetchData())
                .then(() => this.$buefy.toast.open('Место в порядке комбо увеличено'))
                .catch(() => this.$buefy.toast.open('Ошибка при смене порядка комбо'))
                .finally(() => {
                    this.loading = false
                })
        },
        downOrder(comboId) {
            this.loading = true;

            comboRepository.downOrder(comboId)
                .then(() => this.fetchData())
                .then(() => this.$buefy.toast.open('Место в порядке комбо уменьшено'))
                .catch(() => this.$buefy.toast.open('Ошибка при смене порядка комбо'))
                .finally(() => {
                    this.loading = false
                })
        },
    },
    mounted() {
        this.fetchData()
    }
}
</script>

<style scoped>

</style>
